export default "__VITE_ASSET__TXxNZ4ej__"